module.exports = __webpack_public_path__ + "static/media/login.67364c71.png";